import { IRoamingInternationalCountry } from "@nju/data-access-portal-dashboard";
import { SelectedCountryDetails } from "../partials";

interface IOfferEUProps {
  selectedCountry: IRoamingInternationalCountry;
}

export function OfferEU({ selectedCountry }: IOfferEUProps) {
  return <SelectedCountryDetails selectedCountry={selectedCountry} />;
}
